var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "dunning-root fs-3" },
    [
      _c("h3", { staticClass: "pb-1 bb-2" }, [
        _vm._v(_vm._s(_vm.$l10n.__("Définition de votre plan de relance")))
      ]),
      _vm._v(" "),
      _c("p", { staticClass: "fs-3 mt-3 gray-60" }, [
        _vm._v(
          "\n        " +
            _vm._s(
              _vm.$l10n.__("Définissez et organisez votre plan de relance.")
            ) +
            "\n    "
        )
      ]),
      _vm._v(" "),
      _vm.steps.length > 0
        ? _c("div", { staticClass: "well flex-row" }, [
            _c("h3", { staticClass: "m-0 step-day" }, [
              _vm._v(_vm._s(_vm.$l10n.__("Jours")))
            ]),
            _vm._v(" "),
            _c("h3", { staticClass: "m-0 step-name" }, [
              _vm._v(_vm._s(_vm.$l10n.__("Nom de la relance")))
            ]),
            _vm._v(" "),
            _c("h3", { staticClass: "m-0 step-contact mr-3" }, [
              _vm._v(_vm._s(_vm.$l10n.__("Destinataire")))
            ])
          ])
        : _vm._e(),
      _vm._v(" "),
      _vm.stepsBefore.length > 0
        ? _c(
            "ul",
            { staticClass: "before-dunning" },
            _vm._l(_vm.stepsBefore, function(step) {
              return _c("li", { key: step.id }, [
                _c(
                  "div",
                  { staticClass: "well" },
                  [
                    _c("span", { staticClass: "step-day" }, [
                      _vm._v(
                        "\n                    " +
                          _vm._s(
                            _vm.$l10n.n__(
                              "%d jour",
                              "%d jours",
                              Math.abs(step.days),
                              step.days
                            )
                          ) +
                          "\n                "
                      )
                    ]),
                    _vm._v(" "),
                    _c("span", { staticClass: "step-name semibold" }, [
                      _vm._v(_vm._s(step.name))
                    ]),
                    _vm._v(" "),
                    _c("span", { staticClass: "step-contact" }, [
                      _vm._v(_vm._s(_vm.recipientText(step.recipient_type)))
                    ]),
                    _vm._v(" "),
                    _c(
                      "el-dropdown",
                      {
                        scopedSlots: _vm._u(
                          [
                            {
                              key: "dropdown",
                              fn: function() {
                                return [
                                  _c(
                                    "el-dropdown-menu",
                                    [
                                      _c(
                                        "el-dropdown-item",
                                        {
                                          nativeOn: {
                                            click: function($event) {
                                              return _vm.edit(step.id)
                                            }
                                          }
                                        },
                                        [
                                          _vm._v(
                                            _vm._s(_vm.$l10n.__("Modifier"))
                                          )
                                        ]
                                      ),
                                      _vm._v(" "),
                                      _c(
                                        "el-dropdown-item",
                                        {
                                          nativeOn: {
                                            click: function($event) {
                                              return _vm.deleteStep({
                                                stepId: step.id,
                                                planId: _vm.planId
                                              })
                                            }
                                          }
                                        },
                                        [
                                          _vm._v(
                                            "\n                                " +
                                              _vm._s(
                                                _vm.$l10n.__("Supprimer")
                                              ) +
                                              "\n                            "
                                          )
                                        ]
                                      )
                                    ],
                                    1
                                  )
                                ]
                              },
                              proxy: true
                            }
                          ],
                          null,
                          true
                        )
                      },
                      [
                        _c("CompassIcon", {
                          attrs: {
                            type: "primary",
                            size: "small",
                            icon: "settings"
                          }
                        })
                      ],
                      1
                    )
                  ],
                  1
                )
              ])
            }),
            0
          )
        : _vm._e(),
      _vm._v(" "),
      _c("p", { staticClass: "well m-0 black-bkg white b-0" }, [
        _vm._v(
          "\n        " +
            _vm._s(_vm.$l10n.__("Date d’échéance de votre document")) +
            "\n    "
        )
      ]),
      _vm._v(" "),
      _c(
        "ul",
        { staticClass: "after-dunning" },
        _vm._l(_vm.stepsAfter, function(step) {
          return _c("li", { key: step.id }, [
            _c(
              "div",
              { staticClass: "well" },
              [
                _c("span", { staticClass: "step-day" }, [
                  _vm._v(
                    "\n                    +" +
                      _vm._s(
                        _vm.$l10n.n__(
                          "%d jour",
                          "%d jours",
                          Math.abs(step.days),
                          step.days
                        )
                      ) +
                      "\n                "
                  )
                ]),
                _vm._v(" "),
                _c("span", { staticClass: "step-name semibold" }, [
                  _vm._v(_vm._s(step.name))
                ]),
                _vm._v(" "),
                _c("span", { staticClass: "step-contact" }, [
                  _vm._v(_vm._s(_vm.recipientText(step.recipient_type)))
                ]),
                _vm._v(" "),
                _c(
                  "el-dropdown",
                  {
                    scopedSlots: _vm._u(
                      [
                        {
                          key: "dropdown",
                          fn: function() {
                            return [
                              _c(
                                "el-dropdown-menu",
                                [
                                  _c(
                                    "el-dropdown-item",
                                    {
                                      nativeOn: {
                                        click: function($event) {
                                          return _vm.edit(step.id)
                                        }
                                      }
                                    },
                                    [_vm._v(_vm._s(_vm.$l10n.__("Modifier")))]
                                  ),
                                  _vm._v(" "),
                                  _c(
                                    "el-dropdown-item",
                                    {
                                      nativeOn: {
                                        click: function($event) {
                                          return _vm.openDeletePopup(step.id)
                                        }
                                      }
                                    },
                                    [_vm._v(_vm._s(_vm.$l10n.__("Supprimer")))]
                                  )
                                ],
                                1
                              )
                            ]
                          },
                          proxy: true
                        }
                      ],
                      null,
                      true
                    )
                  },
                  [
                    _c("CompassIcon", {
                      attrs: {
                        type: "primary",
                        size: "small",
                        icon: "settings"
                      }
                    })
                  ],
                  1
                )
              ],
              1
            )
          ])
        }),
        0
      ),
      _vm._v(" "),
      _c("CompassButton", {
        staticClass: "mt-2",
        attrs: {
          label: _vm.$t.__("preferences.Dunning.Step.add_dunning"),
          type: "tertiary"
        },
        on: {
          click: function($event) {
            return _vm.create()
          }
        }
      }),
      _vm._v(" "),
      _c("CompassDialog", {
        staticClass: "step-modal",
        attrs: {
          visible: _vm.confirmationVisible,
          size: "small",
          title: _vm.$t.__("preferences.Dunning.Step.deleting_dunning")
        },
        on: {
          "update:visible": function($event) {
            _vm.confirmationVisible = $event
          }
        },
        scopedSlots: _vm._u([
          {
            key: "default",
            fn: function() {
              return [
                _c("div", { staticClass: "dialog__default" }, [
                  _c(
                    "span",
                    { staticClass: "typographies-paragraph-medium-regular" },
                    [
                      _vm._v(
                        "\n                    " +
                          _vm._s(
                            _vm.$l10n.__(
                              'Confirmez-vous vouloir supprimer la relance "%(stepName)s"',
                              {
                                stepName: _vm.stepNameToDelete
                              }
                            )
                          ) +
                          "\n                "
                      )
                    ]
                  )
                ])
              ]
            },
            proxy: true
          },
          {
            key: "footer",
            fn: function() {
              return [
                _c(
                  "div",
                  { staticClass: "dialog__footer" },
                  [
                    _c("CompassButton", {
                      attrs: {
                        label: _vm.$t.__("common.actions.cancel"),
                        type: "secondary"
                      },
                      on: {
                        click: function($event) {
                          _vm.confirmationVisible = false
                        }
                      }
                    }),
                    _vm._v(" "),
                    _c("CompassButton", {
                      staticClass: "ml-3",
                      attrs: {
                        label: _vm.$t.__("common.actions.delete"),
                        type: "primary-destructive",
                        loading: _vm.loading
                      },
                      on: {
                        click: function($event) {
                          return _vm.confirmDelete()
                        }
                      }
                    })
                  ],
                  1
                )
              ]
            },
            proxy: true
          }
        ])
      }),
      _vm._v(" "),
      _vm.formVisible
        ? _c("step-form", {
            attrs: {
              planId: _vm.planId,
              visible: _vm.formVisible,
              recipientTypeList: _vm.recipientTypeList,
              init: _vm.current
            },
            on: {
              "update:visible": function($event) {
                _vm.formVisible = $event
              }
            }
          })
        : _vm._e()
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }